import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { trackEvent } from "../../analytics";
import { ANALYTICS } from "../../lib/analyticsEvents";
import { logErsteHaushalteResponse } from "../../lib/ersteHaushalteLog";
import {
  ERSTE_HAUSHALTE_DETAIL_MAX,
  ERSTE_HAUSHALTE_HEADLINE,
  ERSTE_HAUSHALTE_LEAD,
  ERSTE_HAUSHALTE_SCENARIO,
  ERSTE_HAUSHALTE_TRUST,
  JOB_OPTIONS,
  ersteHaushalteChatPath,
  normalizeErsteHaushalteDetail,
} from "../../lib/ersteHaushalte";
import "../../pages/SchoolInboxPage.css";
import "./ErsteHaushalteGuestPreview.css";

const JOB_CHOICES = JOB_OPTIONS.filter((option) => option.id !== "other");
const OTHER_OPTION = JOB_OPTIONS.find((option) => option.id === "other");

export default function ErsteHaushalteGuestPreview() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [answer, setAnswer] = useState(null);
  const [otherDraft, setOtherDraft] = useState("");
  const utmSource = searchParams.get("utm_source");
  const utmScenario =
    searchParams.get("utm_scenario") || ERSTE_HAUSHALTE_SCENARIO;

  useEffect(() => {
    trackEvent(ANALYTICS.kita_landing_view, { scenario: utmScenario });
  }, [utmScenario]);

  const goToChat = (job, detail = null) => {
    trackEvent(ANALYTICS.erste_haushalte_tap, {
      answer: job,
      ...(job === "other" ? { has_detail: Boolean(detail) } : {}),
    });
    void logErsteHaushalteResponse({
      answer: job,
      detail,
      utmSource,
      utmScenario,
    });
    navigate(ersteHaushalteChatPath({ answer: job }), { replace: true });
  };

  const handleJob = (option) => {
    if (option.id === "other") {
      setAnswer(option.id);
      setOtherDraft("");
      return;
    }
    goToChat(option.id);
  };

  const handleOtherContinue = () => {
    goToChat("other", normalizeErsteHaushalteDetail(otherDraft));
  };

  const showJobs = !answer;
  const showOther = answer === "other";

  return (
    <div className="erste-haushalte-page">
      <header className="erste-haushalte-header">
        <h2 className="erste-haushalte-title">{ERSTE_HAUSHALTE_HEADLINE}</h2>
        <p className="erste-haushalte-lead">{ERSTE_HAUSHALTE_LEAD}</p>
      </header>

      {showJobs ? (
        <div
          className="erste-haushalte-options"
          role="group"
          aria-label={ERSTE_HAUSHALTE_HEADLINE}
        >
          {JOB_CHOICES.map((option) => (
            <button
              key={option.id}
              type="button"
              className="erste-haushalte-option"
              onClick={() => handleJob(option)}
            >
              <span>{option.label}</span>
              <span className="erste-haushalte-option-chevron" aria-hidden="true">
                ›
              </span>
            </button>
          ))}
          {OTHER_OPTION ? (
            <button
              type="button"
              className="erste-haushalte-anders"
              onClick={() => handleJob(OTHER_OPTION)}
            >
              {OTHER_OPTION.label}
            </button>
          ) : null}
          <p className="erste-haushalte-trust">{ERSTE_HAUSHALTE_TRUST}</p>
        </div>
      ) : null}

      {showOther ? (
        <div className="erste-haushalte-other">
          <p className="erste-haushalte-question">Was genau?</p>
          <textarea
            className="erste-haushalte-detail"
            value={otherDraft}
            onChange={(e) => setOtherDraft(e.target.value)}
            maxLength={ERSTE_HAUSHALTE_DETAIL_MAX}
            rows={3}
            placeholder="Optional — ein Stichwort reicht"
            aria-label="Was genau?"
          />
          <div className="erste-haushalte-other-actions">
            <button
              type="button"
              className="school-btn school-btn--primary"
              onClick={handleOtherContinue}
            >
              Weiter
            </button>
            <button
              type="button"
              className="erste-haushalte-back"
              onClick={() => {
                setAnswer(null);
                setOtherDraft("");
              }}
            >
              Zurück
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
